<template>
  <w-navigation
    :object="user"
    :params="{
      name: 'ProfilePage',
      params: { slug: user.slug }
    }"
  >
    <template #link>
      <article class="user-article">
        <img
          v-if="user?.thumbnails && user.thumbnails.s_sq"
          class="user-img"
          :src="user.thumbnails.s_sq"
          :alt="
            $t('wegow.profile.altDefaultImage', {
              element: `${user.first_name} ${user.last_name}`
            })
          "
        />
        <img
          v-else-if="user?.image_url"
          :src="user?.image_url"
          class="user-img"
          :alt="
            $t('wegow.profile.altDefaultImage', {
              element: `${user.first_name} ${user.last_name}`
            })
          "
          @error="
            $event.target.src = require('@/assets/images/placeholder-user-square.svg')
          "
        />
        <img
          v-else
          :src="require('@/assets/images/placeholder-user-square.svg')"
          class="user-img"
          :alt="$t('wegow.profile.altDefaultWegowImage')"
        />

        <div v-if="!isFake" class="image-overlay">
          <p class="overlay-text">{{ user.first_name }} {{ user.last_name }}</p>
          <div v-if="user.friendship && user.friendship.status == 'none'">
            <button
              class="cursor-pointer flex items-center justify-end font-museo-700 text-[11px]
            right-1 bottom-1 absolute text-color-topaz-light"
              @click.prevent="sendFriendshipRequest(user)"
            >
              {{ $t("general.follow") }}
              <w-icon
                :img="require('@/assets/images/ic-follow.svg')"
                :size="15"
                :alt="$t('wegow.profile.altIcon')"
              />
            </button>
          </div>
          <div
            v-else-if="
              user.friendship && user.friendship.status == 'request_received'
            "
          >
            <p
              class="cursor-pointer flex items-center justify-end gap-2 font-museo-700 text-[11px] absolute right-0 bottom-0"
              @click.prevent="acceptFriendshipRequest(user)"
            >
              {{ $t("wegow.profile.acceptFriendship") }}
              <w-icon
                :img="require('@/assets/images/ic-follow.svg')"
                :size="15"
                :alt="$t('wegow.acceptFriendship')"
              />
            </p>
          </div>
          <div
            v-else-if="
              user.friendship && user.friendship.status == 'request_sent'
            "
          >
            <p
              class="text-right gap-2 font-museo-700 text-xs absolute right-1 bottom-1"
            >
              {{ $t("wegow.profile.senedAbrvFriendship") }}
            </p>
          </div>
          <div v-else-if="user.friendship && user.friendship.status == 'self'">
            <p
              class="text-right gap-2 font-museo-700 text-xs white absolute bottom-1 right-1"
            >
              {{ $t("wegow.profile.self") }}
            </p>
          </div>
          <span v-else>
            <img
              v-if="user.friendship.common_events"
              :src="require('@/assets/images/ic-ticket-topaz.svg')"
              :alt="$t('wegow.altIcon')"
              class="ticket-button"
              :full="false"
              loading="lazy"
            />
            <router-link :to="{ name: 'ChatPage', query: { user: user.id } }">
              <img
                :src="require('@/assets/images/ic-comment-topaz.svg')"
                :alt="$t('wegow.altIcon')"
                class="chat-button"
                :full="false"
                loading="lazy"
              />
            </router-link>
          </span>
        </div>
      </article>
    </template>
  </w-navigation>
</template>

<script setup>
import { useUser } from "@/composables/useUser";
import WIcon from "@/components/general/ui/elements/WIcon.vue";
import WNavigation from "@/components/general/ui/WNavigation";

const { sendFriendshipRequest, acceptFriendshipRequest } = useUser();
const props = defineProps({
  user: {
    type: Object,
    default: undefined
  },
  isFake: {
    type: Boolean,
    default: false
  }
});
</script>

<style lang="scss" scoped>
.user-article {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 6px;
  cursor: pointer;
  .user-img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 6px;
    object-fit: cover;
  }
  &:hover .image-overlay {
    background-color: rgba(0, 2, 20, 0.7);
    display: block;
  }
  &:active .image-overlay {
    background-color: rgba(0, 2, 20, 0.7);
    display: block;
  }
}
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $backgroundBlack;
  display: none;
  transition: opacity 0.3s;
  .overlay-text {
    width: 80%;
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 12px;
    font-weight: 600;
    z-index: 1;
    display: inline-block;
    white-space: normal;
    overflow-wrap: break-word;
  }
}
.ticket-button {
  width: 17px;
  height: 14px;
  position: absolute;
  bottom: 10%;
  left: 10%;
}
.chat-button {
  width: 25px;
  height: 19px;
  position: absolute;
  bottom: 8%;
  right: 10%;
}
</style>
